/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { ListSelfEmployedTransactionsQueryResponse, ListSelfEmployedTransactionsQueryParams, ListSelfEmployedTransactions400, ListSelfEmployedTransactions401, ListSelfEmployedTransactions500 } from "../entities/ListSelfEmployedTransactions";

function getListSelfEmployedTransactionsUrl() {
  const res = { method: 'GET', url: `/api/v1/self-employed/transactions` as const }
  return res
}

/**
 * @description Возвращает историю операций водителя: начисления, выводы и возвраты.
 * Сортировка: `created_at` по убыванию, при равной дате — `id` по возрастанию.
 * Если операций не было, ответ `200` и `transactions: []`. Это не ошибка.
 * Фильтра по категориям пока нет: во фрейме Figma «История транзакций баланса» вкладки
 * «Все / Доход / Доплата / Вывод / Другое» скрыты, ручка возвращает все операции.
 * Если вкладки включат, понадобится параметр `category`, категория определяется по `type`.
 * Элемент списка: `id`, `amount` (копейки, без знака), `created_at`, `type`.
 * `status` (`success`, `waiting`, `canceled`) есть только у `order` и `payout`.
 * У `compensation`, `refund`, `dotaion` и `achivment` поля `status` нет.
 * Знак суммы на экране клиент берёт из `type`: начисление — `order`, `compensation`,
 * `dotaion`, `achivment`; списание — `payout`, `refund`.
 * **Требования:**
 * - JWT access-токен водителя в заголовке `Authorization: Bearer <token>`. Водитель берётся
 * из токена (`user_id` в claims), заголовки `user-id` и `city-id` не нужны и не учитываются
 * **Пагинация:**
 * - Курсорная пагинация
 * - `limit` — количество записей (1–100, по умолчанию 20)
 * - `cursor` — курсор следующей страницы (`next_cursor` из предыдущего ответа).
 * Непрозрачная строка: фронт передаёт её как есть, не разбирает и не собирает
 * @summary История транзакций
 * {@link /api/v1/self-employed/transactions}
 */
export async function listSelfEmployedTransactions(params?: ListSelfEmployedTransactionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSelfEmployedTransactionsQueryResponse, ResponseErrorConfig<ListSelfEmployedTransactions400 | ListSelfEmployedTransactions401 | ListSelfEmployedTransactions500>, unknown>({ method : "GET", url : getListSelfEmployedTransactionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}